import { ExporterConfigurationPropertyValue, PublishedDocEnvironment, } from "../../dsm";
import { ExporterPropertyValueMap } from "../export-configuration";
import { z } from "zod";
export const ExportJobDocumentationContext = z.object({
    isSingleVersionDocs: z.boolean(),
    versionSlug: z.string(),
    environment: PublishedDocEnvironment,
});
export const ExportJobDebugContext = z.object({
    debugMode: z.boolean().optional(),
    concurrency: z.number().optional(),
    preloadData: z.string().optional(),
    concurrencyMode: z.string().optional(),
    cacheSdk: z.string().optional(),
    logSdkNetwork: z.boolean().optional(),
    profilerMode: z.string().optional(),
});
export const ExportJobContext = z.object({
    apiUrl: z.string(),
    accessToken: z.string(),
    // TODO Artem: this can be made non-optional once the commit containing this change
    // gets deployed to production.
    workspaceId: z.string().optional(),
    designSystemId: z.string(),
    designSystemName: z.string(),
    exporterId: z.string(),
    versionId: z.string(),
    brandId: z.string().optional(),
    themeId: z.string().optional(),
    themePersistentIds: z.string().array().optional(),
    contextIds: z.string().array().optional(),
    previewMode: z.boolean().optional(),
    exporterName: z.string(),
    documentation: ExportJobDocumentationContext.optional(),
    debug: ExportJobDebugContext.optional(),
});
export const ExportJobExporterConfiguration = z.object({
    exporterPackageUrl: z.string(),
    exporterPropertyValues: ExporterConfigurationPropertyValue.array(),
    exporterPropertyValuesV2: ExporterPropertyValueMap.optional(),
});
